var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-sensitive",on:{"click":_vm.handleClick}},[_c('xc-icon',{staticClass:"edit-in-table",attrs:{"iconClass":_vm.state?'hide_icon':'detail'}}),_vm._v(" "),_c('span',{staticClass:"view-sensitive-label"},[_vm._v(_vm._s(_vm.state?"隐藏":_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }